export default "__VITE_ASSET__IVgWtwh9__"